module.exports = __webpack_public_path__ + "static/media/slide1.a89b8f05.jpg";